import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Container } from 'reactstrap';
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm';
import './TechGrowthHe.css';

/* ─── ANIMATION PRESETS ─── */
const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.55, ease: [0.4, 0, 0.2, 1], delay },
});

/* ─── DATA ─── */
const services = [
  {
    icon: 'las la-comments',
    title: 'ייעוץ ותכנון טכנולוגי לעסק בצמיחה',
    desc: 'לפני שמטמיעים מערכת, חשוב להבין את התמונה המלאה: איך העסק פועל היום, איפה צווארי הבקבוק, אילו תהליכים גוזלים זמן, ואילו כלים ישרתו את היעדים העסקיים.',
    bullets: [
      'התאמה בין הטכנולוגיה ליעדי הצמיחה',
      'צמצום טעויות בהחלטות רכישה והטמעה',
      'בניית תהליך מסודר במקום פתרונות נקודתיים',
      'חיסכון בזמן, עלויות ותיקונים בעתיד',
    ],
    result: 'תשתית מותאמת לצרכים אמיתיים, לא רשימת כלים מנותקת מהמציאות.',
  },
  {
    icon: 'las la-user-friends',
    title: 'CRM – ניהול לקוחות ותהליכי מכירה',
    desc: 'מערכת CRM מרכזת במקום אחד את הלידים, הלקוחות, הפניות, ההזדמנויות ותהליך המכירה.',
    bullets: [
      'מעקב מסודר אחר כל ליד ולקוח',
      'הפחתת אובדן פניות והזדמנויות',
      'שיפור תהליך המכירה והמעקב',
      'יצירת סטנדרט עבודה ברור לצוות',
      'חיבור לאוטומציות, תזכורות ותהליכי המשך',
    ],
    result: 'יותר שליטה בצינור המכירה ושיפור ביכולת להפוך פניות להכנסות.',
  },
  {
    icon: 'las la-chart-bar',
    title: 'ניתוח נתונים ודשבורדים עם Metabase',
    desc: 'מערכת דשבורדים מאפשרת להפוך נתונים גולמיים לתובנות ברורות ולנהל את העסק לפי נתונים אמיתיים.',
    bullets: [
      'מעקב אחר הכנסות, הוצאות, מכירות וביצועים',
      'זיהוי מגמות, בעיות והזדמנויות',
      'שיפור קבלת החלטות ניהוליות',
      'שקיפות בין הנהלה, מכירות ותפעול',
      'הגדרת KPI ברורים ומדידתם לאורך זמן',
    ],
    result: 'פחות ניחושים, יותר שליטה — ניהול צמיחה על בסיס מידע.',
  },
  {
    icon: 'las la-robot',
    title: 'OpenClaw – בינה מלאכותית אוטונומית',
    desc: 'שכבת אוטומציה ובינה מלאכותית שמאפשרת לבצע פעולות חוזרות, לאתר מידע, לנתח נתונים ולתמוך בתהליכי עבודה.',
    bullets: [
      'אוטומציה של תהליכים תפעוליים ושיווקיים',
      'סיוע באיסוף מידע עסקי וניתוחו',
      'חיסכון בזמן עבודה ידני',
      'תמיכה בתהליכי שירות, מכירה ומעקב',
      'שיפור יעילות העבודה בצוותים קטנים',
    ],
    result: 'יכולת להגדיל תפוקה בלי להגדיל מיד את העומס האנושי.',
  },
  {
    icon: 'las la-sitemap',
    title: 'ERP – ניהול כולל של הפעילות העסקית',
    desc: 'מערכת ERP מרכזת ניהול כוח אדם, מלאי, מוצרים, ייצור, חומרי גלם ותהליכים תפעוליים ופיננסיים.',
    bullets: [
      'תהליך עבודה אחיד ומרוכז',
      'שליטה טובה יותר על מלאי, תפעול ושרשרת עבודה',
      'הקטנת טעויות אנוש',
      'שיפור יעילות וניהול משאבים',
      'בסיס חזק להתרחבות עתידית',
    ],
    result: 'עסק שעובד בצורה מסודרת ומתואמת גם כשהיקפי הפעילות גדלים.',
  },
  {
    icon: 'las la-tasks',
    title: 'מערכת ניהול פרויקטים',
    desc: 'כאשר יש יותר לקוחות, עובדים ומשימות — ניהול לא מסודר מתחיל לעלות בזמן, בכסף ובאיכות ביצוע.',
    bullets: [
      'חלוקת אחריות ברורה',
      'מעקב אחר התקדמות וביצועים',
      'הפחתת עומס תקשורתי מיותר',
      'שיפור תיאום בין עובדים, מנהלים וספקים',
      'ניהול מסודר של משימות, זמנים ויעדים',
    ],
    result: 'יותר ביצוע, פחות בלגן — יכולת להתרחב בלי לאבד שליטה.',
  },
  {
    icon: 'las la-clock',
    title: 'מערכת מדידת זמן',
    desc: 'מערכת מדידת זמן מספקת תמונה ברורה על השקעת המשאבים בפועל, ברמת עובד, משימה, פרויקט או לקוח.',
    bullets: [
      'הבנה אמיתית של עלויות זמן',
      'תמחור מדויק יותר של שירותים ופרויקטים',
      'זיהוי בזבוזי זמן וחוסר יעילות',
      'שיפור ניהול עומסים ותפוקה',
      'בקרה טובה יותר על משימות צוות',
    ],
    result: 'ניהול יעיל יותר של זמן, משאבים ורווחיות.',
  },
  {
    icon: 'las la-shopping-cart',
    title: 'eCommerce – חנות מסחר דיגיטלית',
    desc: 'חנות אונליין מאפשרת לעסק להרחיב ערוצי מכירה, להגיע ללקוחות חדשים ולבצע מכירה מעבר לשעות הפעילות.',
    bullets: [
      'פתיחת ערוץ מכירה נוסף',
      'זמינות ללקוחות בכל שעה',
      'אוטומציה של הזמנות, תשלומים ותהליכי המשך',
      'הרחבת קהל היעד מעבר לאזור גיאוגרפי',
      'חיבור למערכות מלאי, CRM ושיווק',
    ],
    result: 'יותר הזדמנויות מכירה, גמישות עסקית ויכולת התרחבות.',
  },
  {
    icon: 'las la-bullhorn',
    title: 'אתר שיווקי וקידום אורגני וממומן',
    desc: 'אתר שיווקי איכותי, יחד עם קידום אורגני וממומן, יוצר תשתית שיווקית יציבה לטווח הקצר והארוך.',
    bullets: [
      'יצירת נראות מקצועית ואמינה',
      'הגדלת החשיפה לקהלים רלוונטיים',
      'יצירת פניות חדשות באופן שוטף',
      'בניית נכס דיגיטלי לטווח ארוך',
      'חיבור בין שיווק, מדידה ומערכות ניהול',
    ],
    result: 'מנוע שיווקי שעוזר לעסק לגדול בצורה עקבית ומבוקרת.',
  },
];

const whoItems = [
  'רוצים לגדול אבל מבינים שהמבנה הנוכחי כבר לא מספיק',
  'מרגישים שהפעילות הופכת מורכבת יותר וקשה לניהול',
  'רוצים לשפר תהליכים, שליטה ומדידה',
  'מחפשים ליווי מקצועי בבחירה והטמעה של מערכות',
  'רוצים לחבר בין טכנולוגיה, תפעול, שיווק וצמיחה עסקית',
];

const whyItems = [
  { icon: 'las la-eye', title: 'הסתכלות רחבה', text: 'מבינים את הצרכים הכוללים ומתאימים תשתית טכנולוגית למטרות העסקיות.' },
  { icon: 'las la-link', title: 'חיבור מערכות', text: 'מחברים בין מערכות שונות לתהליך עבודה אחד, אחיד ויעיל.' },
  { icon: 'las la-chart-line', title: 'שיפור ביצועים', text: 'כל כלי שמוטמע מיועד לייצר ערך עסקי אמיתי ומדיד.' },
  { icon: 'las la-rocket', title: 'בסיס לצמיחה', text: 'בונים תשתית ניהולית וטכנולוגית שתומכת בהתרחבות עתידית.' },
];

const shiftItems = [
  { from: 'לרדוף אחרי משימות', to: 'לנהל תהליכים' },
  { from: 'לעבוד לפי תחושת בטן', to: 'לעבוד לפי נתונים' },
  { from: 'להסתמך על אנשים מסוימים', to: 'לבנות שיטה' },
  { from: 'להיתקע בתפעול', to: 'לפנות זמן לצמיחה' },
];


const aiAgents = [
  {
    icon: 'las la-envelope-open-text',
    title: 'אדמיניסטרציה',
    description: 'ממיין מיילים, מכין טיוטות תשובה, מסייע ביומן ומסכם פגישות.',
    benefit: 'פחות עבודה ידנית ופחות דברים שנופלים בין הכיסאות.',
  },
  {
    icon: 'las la-share-alt',
    title: 'שיווק ברשתות החברתיות',
    description: 'מציע רעיונות, יוצר תוכן ומתזמן פרסומים.',
    benefit: 'נוכחות עקבית בלי להכין כל פוסט מאפס.',
  },
  {
    icon: 'las la-handshake',
    title: 'מכירות B2B',
    description: 'מאתר לקוחות פוטנציאליים, מכין פניות אישיות ומנהל מעקב.',
    benefit: 'יותר הזדמנויות לשיחות מכירה ופחות זמן על איתור ידני.',
  },
  {
    icon: 'las la-search',
    title: 'שיווק אורגני באתר',
    description: 'חוקר נושאים וכותב מאמרים מותאמים לחיפוש.',
    benefit: 'תוכן רלוונטי שיכול להביא תנועה ופניות לאורך זמן.',
  },
  {
    icon: 'las la-laptop-code',
    title: 'שיפור האתר',
    description: 'בונה עמודים ובוחן שינויים בכותרות, בתמונות ובכפתורים.',
    benefit: 'החלטות המבוססות על התנהגות מבקרים כדי לשפר פניות מהאתר.',
  },
  {
    icon: 'las la-file-contract',
    title: 'סיוע במסמכים משפטיים',
    description: 'מסייע בהכנת טיוטות ובהבנת סעיפים בהסכמים.',
    benefit: 'חוסך זמן בהכנה ובסקירה ראשונית.',
    disclaimer: 'אינו מהווה ייעוץ משפטי ואינו מחליף בדיקה של עורך דין מוסמך.',
  },
];

/* ─── COMPONENT ─── */
export default function TechGrowthHe() {
  const scrollToForm = (e) => {
    e.preventDefault();
    const formElement = document.getElementById('epic-tech-growth-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="tg-page">
      <Helmet>
        <title>ליווי טכנולוגי לעסקים בצמיחה</title>
        <meta name="description" content="ליווי טכנולוגי לעסקים קטנים ובינוניים שרוצים לצמוח: CRM, ERP, דשבורדים, אוטומציה, ניהול פרויקטים וקידום דיגיטלי." />
        <meta name="keywords" content="ליווי טכנולוגי, פיתוח לעסקים, ייעוץ טכנולוגי, CRM, ERP, אוטומציה לעסקים, ניהול פרויקטים, צמיחה עסקית, דשבורדים, בינה מלאכותית לעסקים, טרנספורמציה דיגיטלית" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://epicfinal.com/he/tech-growth" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://epicfinal.com/he/tech-growth" />
        <meta property="og:title" content="ליווי טכנולוגי לעסקים בצמיחה" />
        <meta property="og:description" content="ליווי טכנולוגי לעסקים קטנים ובינוניים שרוצים לצמוח: CRM, ERP, דשבורדים, אוטומציה, ניהול פרויקטים וקידום דיגיטלי." />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://epicfinal.com/he/tech-growth" />
        <meta name="twitter:title" content="ליווי טכנולוגי לעסקים בצמיחה" />
        <meta name="twitter:description" content="ליווי טכנולוגי לעסקים קטנים ובינוניים שרוצים לצמוח: CRM, ERP, דשבורדים, אוטומציה, ניהול פרויקטים וקידום דיגיטלי." />
      </Helmet>

      {/* ══ HERO ══ */}
      <section className="tg-hero">
        <Container>
          <motion.div
            className="tg-hero-inner"
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className="tg-hero-badge">
              <i className="las la-seedling" />
              ליווי טכנולוגי לעסקים
            </div>

            <h1>ליווי טכנולוגי לעסקים שרוצים לצמוח נכון</h1>

            <p>
              פתרון מותאם לעסקים בצמיחה: ייעוץ, מערכות ניהול, אוטומציה, דאטה וכלים
              טכנולוגיים שיעזרו לעסק לעבוד חכם, מסודר ומוכן להתרחבות.
            </p>

            <div className="tg-hero-btns">
              <button
                type="button"
                className="tg-btn-primary"
                onClick={scrollToForm}
              >
                <i className="las la-envelope" />
                השאירו פרטים
              </button>
              <a
                href="https://meetings.hubspot.com/viacheslav-seifer"
                target="_blank"
                rel="noopener noreferrer"
                className="tg-btn-ghost"
              >
                <i className="las la-calendar" />
                קבע שיחת ייעוץ
              </a>
            </div>
          </motion.div>
        </Container>
      </section>

      {/* ══ INTRO ══ */}
      <section className="tg-section--white">
        <Container>
          <Link to="/he" className="tg-back">
            <i className="las la-arrow-right" />
            חזרה לדף הראשי
          </Link>

          <motion.div className="tg-intro-card" {...fadeUp()}>
            <p>
              עסק שנמצא בתהליך צמיחה מתמודד בדרך כלל עם אתגרים חדשים: יותר לקוחות, יותר
              משימות, יותר עובדים, יותר מידע, ויותר צורך בשליטה, סדר ויכולת קבלת החלטות.
            </p>
            <p>
              בשלב הזה, עבודה ידנית, כלים מפוזרים ותהליכים לא מסודרים{' '}
              <span className="tg-highlight">כבר לא מספיקים</span>. כדי לגדול בצורה יציבה,
              עסק צריך תשתית טכנולוגית שתומכת בצמיחה שלו — ולא מעכבת אותה.
            </p>
            <p>
              אנחנו מספקים ליווי טכנולוגי לעסקים שרוצים להתקדם לשלב הבא — באמצעות ייעוץ,
              תכנון, הטמעה וחיבור של מערכות שמאפשרות
              לעסק לעבוד בצורה יעילה יותר, מדויקת יותר ורווחית יותר.
            </p>
            <div className="tg-tagline">
              <i className="las la-bolt" />
              טכנולוגיה עסקית היא לא מותרות. היא מנוע צמיחה.
            </div>
          </motion.div>
        </Container>
      </section>

      {/* ══ MINDSET SHIFT ══ */}
      <section className="tg-section--dark">
        <div className="tg-inner">
          <Container>
            <motion.div className="tg-section-header tg-section-header--dark" {...fadeUp()}>
              <span className="tg-section-eyebrow tg-section-eyebrow--dark">שינוי גישה</span>
              <h2>כאשר העסק גדל, נדרש מעבר לגישה ניהולית</h2>
              <p>מגישה תגובתית לגישה ניהולית — זה לא רק כלים, זו תפיסה שלמה.</p>
            </motion.div>

            <div className="tg-shift-grid">
              {shiftItems.map((item, i) => (
                <motion.div key={i} className="tg-shift-card" {...fadeUp(i * 0.09)}>
                  <span className="tg-shift-arrow"><i className="las la-long-arrow-alt-down" /></span>
                  <div className="tg-shift-from">
                    במקום: <span>{item.from}</span>
                  </div>
                  <div className="tg-shift-to">{item.to}</div>
                </motion.div>
              ))}
            </div>
          </Container>
        </div>
      </section>

      {/* ══ SERVICES ══ */}
      <section className="tg-section">
        <Container>
          <motion.div className="tg-section-header" {...fadeUp()}>
            <span className="tg-section-eyebrow">הכלים שלנו</span>
            <h2>מה כולל הליווי הטכנולוגי</h2>
            <p>כלים ומערכות מותאמים לשלבי הצמיחה השונים של העסק</p>
          </motion.div>

          <div className="tg-services-grid">
            {services.map((svc, i) => (
              <motion.div key={i} className="tg-service-card" {...fadeUp(i * 0.055)}>
                <div className="tg-service-icon">
                  <i className={svc.icon} />
                </div>
                <h3 className="tg-service-title">{svc.title}</h3>
                <p className="tg-service-desc">{svc.desc}</p>
                <ul className="tg-service-bullets">
                  {svc.bullets.map((b, j) => (
                    <li key={j}>
                      <i className="las la-check-circle" />
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="tg-service-result">
                  <i className="las la-trophy" />
                  {svc.result}
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>

      {/* ══ AI AGENTS ══ */}
      <section className="tg-ai-section" aria-labelledby="tg-ai-title">
        <Container>
          <motion.div className="tg-section-header" {...fadeUp()}>
            <span className="tg-section-eyebrow">סוכני AI לעסקים</span>
            <h2 id="tg-ai-title">סוכני בינה מלאכותית שעובדים בשביל העסק שלכם</h2>
          </motion.div>

          <div className="tg-ai-grid">
            {aiAgents.map((agent, index) => (
              <motion.article
                key={agent.title}
                className="tg-ai-card"
                {...fadeUp((index % 3) * 0.07)}
              >
                <div className="tg-ai-card-header">
                  <span className="tg-ai-icon" aria-hidden="true">
                    <i className={agent.icon} />
                  </span>
                  <h3>{agent.title}</h3>
                </div>
                <p className="tg-ai-description">{agent.description}</p>
                <div className="tg-ai-benefit">
                  <span className="tg-ai-benefit-label">הערך לעסק</span>
                  <p>{agent.benefit}</p>
                  {agent.disclaimer && (
                    <strong className="tg-ai-disclaimer">{agent.disclaimer}</strong>
                  )}
                </div>
              </motion.article>
            ))}
          </div>

          <motion.div className="tg-ai-custom" {...fadeUp()}>
            <div className="tg-ai-custom-copy">
              <span className="tg-ai-custom-label">
                <i className="las la-magic" aria-hidden="true" />
                סוכן AI מותאם אישית
              </span>
              <h3>צריכים סוכן שמתאים בדיוק לעסק שלכם?</h3>
              <p>
                <strong>נבנה עבורכם סוכן בינה מלאכותית מותאם אישית</strong> לתהליך,
                לצוות ולמערכות שכבר נמצאות בשימוש אצלכם — כדי לצמצם עבודה ידנית
                ולתת למידע ולמשימות להתקדם.
              </p>
            </div>
            <button type="button" className="tg-ai-custom-cta" onClick={scrollToForm}>
              בואו נדבר על הסוכן שלכם
              <i className="las la-arrow-left" aria-hidden="true" />
            </button>
          </motion.div>
        </Container>
      </section>

      {/* ══ WHO IT'S FOR ══ */}
      <section className="tg-section--white">
        <Container>
          <motion.div className="tg-section-header" {...fadeUp()}>
            <span className="tg-section-eyebrow">קהל היעד</span>
            <h2>למי השירות מתאים</h2>
            <p>הליווי מתאים לעסקים קטנים ובינוניים שנמצאים בתהליך צמיחה</p>
          </motion.div>

          <div className="tg-who-grid">
            {whoItems.map((item, i) => (
              <motion.div key={i} className="tg-who-card" {...fadeUp(i * 0.08)}>
                <i className="las la-check-circle" />
                <span>{item}</span>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>

      {/* ══ WHY US ══ */}
      <section className="tg-section">
        <Container>
          <motion.div className="tg-section-header" {...fadeUp()}>
            <span className="tg-section-eyebrow">היתרון שלנו</span>
            <h2>למה לעבוד איתנו</h2>
            <p>
              אנחנו לא מציעים רק מערכת. אנחנו מספקים הסתכלות רחבה על העסק, מבינים את הצרכים
              ומתאימים תשתית טכנולוגית שתשרת את המטרות העסקיות שלך.
            </p>
          </motion.div>

          <div className="tg-why-grid">
            {whyItems.map((item, i) => (
              <motion.div key={i} className="tg-why-card" {...fadeUp(i * 0.1)}>
                <div className="tg-why-icon-wrap">
                  <i className={item.icon} />
                </div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>

      {/* ══ CLOSING ══ */}
      <section className="tg-section--dark">
        <div className="tg-inner">
          <Container>
            <motion.div className="tg-quote-block" {...fadeUp()}>
              <h2>צמיחה עסקית דורשת תשתית נכונה</h2>
              <p>
                עסקים לא גדלים רק בזכות יותר מכירות. הם גדלים כאשר יש להם יכולת לתמוך
                בצמיחה: לנהל מידע, לייעל תהליכים, למדוד ביצועים ולעבוד בצורה חכמה יותר.
              </p>
              <p>
                זה בדיוק המקום שבו ליווי טכנולוגי נכון{' '}
                <strong>הופך מהוצאה להשקעה</strong>.
              </p>
            </motion.div>
          </Container>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section className="tg-section--white">
        <Container>
          <motion.div className="tg-cta-box" {...fadeUp()}>
            <h2>רוצה לבנות תשתית שתאפשר לעסק שלך לגדול?</h2>
            <p>
              אנחנו מזמינים אותך לבחון יחד אילו מערכות, תהליכים ופתרונות יכולים להתאים
              לעסק שלך היום — ולתמוך בו גם בשלב הבא.
            </p>
            <div className="tg-cta-btns">
              <button
                type="button"
                className="tg-cta-primary"
                onClick={scrollToForm}
              >
                <i className="las la-envelope" />
                השאירו פרטים
              </button>
              <a
                href="https://meetings.hubspot.com/viacheslav-seifer"
                target="_blank"
                rel="noopener noreferrer"
                className="tg-cta-secondary"
              >
                <i className="las la-calendar" />
                קבע שיחת ייעוץ
              </a>
            </div>
            <p className="tg-cta-foot">
              ליווי טכנולוגי לעסקים שרוצים לצמוח עם סדר, שליטה וחשיבה קדימה.
            </p>
          </motion.div>
        </Container>
      </section>

      <ConsultingForm
        formId="epic-tech-growth-form"
        conversionSendTo="AW-11461100984/xbPsCK-mtZgcELiLitkq"
        conversionValue={1.0}
        title="ספרו לנו איפה העסק שלכם צריך תמיכה כדי לגדול נכון"
        subtitle="השאירו פרטים קצרים ונחזור אליכם עם כיוון ראשוני למערכות, אוטומציה ותשתית טכנולוגית שתתמוך בצמיחה של העסק שלכם."
      />
    </div>
  );
}
